import React, { useState, useEffect } from "react";
import styles from "./Projects.module.css";
/* global Tawk_API paypal */
// ⭐ مكون التقييم النجوم
function RatingStars({ projectTitle }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [isRated, setIsRated] = useState(false);

  useEffect(() => {
    const savedRating = localStorage.getItem(`rating-${projectTitle}`);
    if (savedRating) {
      setRating(parseInt(savedRating));
      setIsRated(true);
    }
  }, [projectTitle]);

  const handleRate = (value) => {
    if (isRated) return;
    setRating(value);
    localStorage.setItem(`rating-${projectTitle}`, value);
    setIsRated(true);
  };

  return (
    <div style={{ marginTop: '10px', display: 'flex' }}>
      {[...Array(5)].map((_, index) => {
        const starValue = index + 1;
        return (
          <i
            key={index}
            className={`fa-star ${starValue <= (hover || rating) ? 'fas' : 'far'}`}
            style={{
              color: starValue <= (hover || rating) ? '#ffc107' : '#ccc',
              cursor: isRated ? 'default' : 'pointer',
              marginRight: '5px',
              fontSize: '18px',
              transition: 'color 0.2s ease'
            }}
            onClick={() => handleRate(starValue)}
            onMouseEnter={() => !isRated && setHover(starValue)}
            onMouseLeave={() => !isRated && setHover(null)}
          ></i>
        );
      })}
    </div>
  );
}

export default function Projects({ isEnglish, theme }) {
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedProject, setSelectedProject] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [detailProject, setDetailProject] = useState(null); // نافذة التفاصيل

  const services = [
    { key: "all", icon: "fa-solid fa-layer-group", label: isEnglish ? "All" : "الكل" },
    { key: "audio", icon: "fa-solid fa-headphones", label: " خدمات الصوت والموسيقى" },
    { key: "writing", icon: "fa-solid fa-book", label: " خدمات الكتابة و التحرير" },
    { key: "translate", icon: "fa-solid fa-globe", label: "و خدمات الترجمة والترجمه" },
    { key: "dev", icon: "fa-solid fa-code", label: " خدمات البرمجة و التطوير" },
    { key: "apps", icon: "fa-solid fa-arrows-split-up-and-left", label: "خدمات التسويق الرقمي" },
    { key: "marketing", icon: "fa-solid fa-dollar-sign", label:  "خدمات المحاسبه و الماليه الرقميه" },
    { key: "tegara", icon: "fa-solid fa-bag-shopping", label: "خدمات التجاره الرقميه المتقدمه" },
    { key: "goraophic", icon: "fa-solid fa-globe", label:  "خدمات البينات و المواقع الجغرافيه" },
    { key: "secure", icon: "fa-solid fa-shield", label: "خدمات الامن السيبراني" },
    { key: "AI", icon: "fa-solid fa-microchip", label: "خدمات الذكاء الاصطناعي و تعام الاله" },
    { key: "devops", icon: "fa-solid fa-server", label: "خدمات البنيه التحتيه  devops" },
    { key: "book", icon: "fa-solid fa-book", label: "خدمات التعليم و التدريب الرقمي" },
  ];

  const projects = [
    {
      title: "إنتاج الموسيقى",
      category: "audio",
      description:"إنشاء مقاطع موسيقية أصلية.",
      tags: ["Audio", "Studio", "Mixing"],
      icon: "fa-solid fa-music",
      price: "٨٠ $",
    },
    {
      title: "تحرير الصوت",
      category: "audio",
      description:"تنقية وتعديل المقاطع الصوتية.",
      tags: ["Audio", "Studio", "Mixing"],
      icon: "fa-solid fa-music",
      price: "٤٥ $",
    },
    {
      title: "التعليق الصوتي",
      category: "audio",
      description:"تسجيل صوتي للمحتوى المرئي أو الإعلانات.",
      tags: ["Audio", "Studio", "Mixing"],
      icon: "fa-solid fa-music",
      price: "٦٠$",
    },
    {
      title: "إزالة الضوضاء الخلفية",
      category: "audio",
      description:"تحسين جودة الصوت بإزالة التشويش.",
      tags: ["Audio", "Studio", "Mixing"],
      icon: "fa-solid fa-music",
      price: "٣٠ $",
    },
    {
      title: "تحويل النص إلى كلام",
      category: "audio",
      description:"تحويل النصوص",
      tags: ["Audio", "Studio", "Mixing"],
      icon: "fa-solid fa-music",
      price: "٣٥ $",
    },
    {
      title: "تحليل التكاليف",
      category: "marketing",
      description:"تقييم النفقات وتحسين الكفاءة المالية.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-dollar-sign",
      price:"75$"
    },
    {
      title: "إدارة الفواتير والمدفوعات",
      category: "marketing",
      description:"أتمتة عمليات الفوترة وتحصيل المدفوعات.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-dollar-sign",
      price:"٨٥ $"
    },
    {
      title: "إعداد التقارير المالية",
      category: "marketing",
      description:"توليد تقارير مالية دقيقة وفي الوقت المناسب.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-dollar-sign",
      price:"٩٥ $"
    },
    {
      title: "تحليل سلة التسوق",
      category: "tegara",
      description:"دراسة سلوك الشراء لتحسين معدلات التحويل.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-bag-shopping",
      price:"٦٥ $"
    },
    {
      title: "إدارة العروض الترويجية",
      category: "tegara",
      description:"تصميم وتنفيذ حملات ترويجية فعالة.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-bag-shopping",
      price:"٧٠ $"
    },
    {
      title: "تحسين تجربة المستخدم",
      category: "tegara",
      description:"تحليل سلوك المستخدمين لتحسين واجهات المتاجر الإلكترونية.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-bag-shopping",
      price:"٨٠ $"
    },
    {
      title: "إدارة البيانات المكانية",
      category: "goraophic",
      description:"تخزين وتنظيم البيانات المرتبطة بالمواقع.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-globe",
      price:"٩٠ $"
    },
    {
      title: "تطوير تطبيقات الخرائط",
      category: "goraophic",
      description:"إنشاء تطبيقات تعتمد على الموقع الجغرافي.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-globe",
      price:"١٢٠ $"
    },
    {
      title: "تحليل البيانات الجغرافية",
      category: "goraophic",
      description:"دراسة البيانات المكانية لاتخاذ قرارات مستنيرة.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-globe",
      price:"١٠٠ $"
    },
    {
      title: "إدارة الهوية والوصول",
      category: "secure",
      description:"التحكم في من يمكنه الوصول إلى الموارد.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-shield",
      price:"٩٠ $"
    },
    {
      title: "مراقبة التهديدات",
      category: "secure",
      description:"تتبع الأنشطة المشبوهة والاستجابة لها",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-shield",
      price:"١٢٠ $"
    },
    {
      title: "اختبار الاختراق",
      category: "secure",
      description:"تقييم أمان الأنظمة من خلال محاكاة الهجمات.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-shield",
      price:"١٥٠ $"
    },
    {
      title: "معالجة اللغة الطبيعية",
      category: "AI",
      description:"تحليل وفهم النصوص البشرية.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-microchip",
      price:"١٥٠ $"
    },
    {
      title: "تطوير نماذج تعلم الآلة",
      category: "AI",
      description:"إنشاء وتدريب نماذج للتنبؤ أو التصنيف.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-microchip",
      price:"١٦٠ $"
    },
    {
      title: "تحليل البيانات الضخمة",
      category: "AI",
      description:"استخراج رؤى من مجموعات بيانات كبيرة.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-microchip",
      price:"١٤٠ $"
    },
    {
      title: "التكامل المستمر والتسليم المستمر",
      category: "devops",
      description:"أتمتة عمليات البناء والاختبار والنشر.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-server",
      price:"١٢٥ $"
    },
    {
      title: "المراقبة والتنبيه",
      category: "devops",
      description:"تتبع أداء الأنظمة وتنبيه الفرق عند حدوث مشكلات.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-server",
      price:"١٠٠ $"
    },
    {
      title: "إدارة الحاويات",
      category: "devops",
      description:"استخدام أدوات مثل Docker وKubernetes.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-server",
      price:"١١٠ $"
    },
    {
      title: "تحليل أداء المتعلمين",
      category: "book",
      description:"تتبع تقدم الطلاب وتقديم تقارير مفصلة.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-book",
      price:"٨٥ $"
    },
    {
      title: "إدارة أنظمة التعلم",
      category: "book",
      description:"تطوير وصيانة منصات التعليم الإلكتروني.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-book",
      price:"١٣٠ $"
    },
    {
      title: "تصميم الدورات التعليمية",
      category: "book",
      description:"إنشاء محتوى تعليمي تفاعلي.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-book",
      price:"١٠٠ $"
    },
    {
      title: "إدارة وسائل التواصل الاجتماعي",
      category: "apps",
      description:"نشر المحتوى والتفاعل مع المتابعين.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-arrows-split-up-and-left",
      price:"٧٠ $"
    },
    {
      title: "تصميم الدورات التعليمية",
      category: "apps",
      description:"إنشاء محتوى تعليمي تفاعلي.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-arrows-split-up-and-left",
      price:"٩٥ $"
    },
    {
      title: "إدارة حملات الإعلانات",
      category: "apps",
      description:"إعداد وإدارة إعلانات على منصات مثل Google وFacebook.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-arrows-split-up-and-left",
      price:"٨٠ $"
    },
    {
      title: "كتابة الإعلانات",
      category: "apps",
      description:"إعداد نصوص جذابة للإعلانات.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-arrows-split-up-and-left",
      price:"٥٥ $"
    },
    {
      title: "تحليل البيانات التسويقية",
      category: "apps",
      description:"دراسة أداء الحملات وتحسينها.",
      tags: ["React", "Node.js", "MongoDB"],
      icon: "fa-solid fa-arrows-split-up-and-left",
      price:"٨٥ $"
    },
    {
      title: "تطوير البرمجيات",
      category: "dev",
      description:"إنشاء برامج مخصصة لاحتياجات معينة.",
      tags: ["React Native", "Firebase", "Social"],
      icon: "fa-solid fa-code",
      price:"٧٠  $"
    },
    {
      title: "تطوير تطبيقات الهواتف",
      category: "dev",
      description:"إنشاء تطبيقات لنظامي Android وiOS.",
      tags: ["React Native", "Firebase", "Social"],
      icon: "fa-solid fa-code",
      price:"٩٥  $"
    },
    {
      title: "تطوير المواقع الإلكترونية",
      category: "dev",
      description:"إنشاء مواقع باستخدام لغات مثل HTML، CSS، وJavaScript.",
      tags: ["React Native", "Firebase", "Social"],
      icon: "fa-solid fa-code",
      price:"٨٠  $"
    },
    {
      title: "تكامل الأنظمة",
      category: "dev",
      description:"ربط أنظمة أو خدمات مختلفة معًا.",
      tags: ["React Native", "Firebase", "Social"],
      icon: "fa-solid fa-code",
      price:"٥٥  $"
    },
    {
      title: "إصلاح الأخطاء البرمجية",
      category: "dev",
      description:"تصحيح المشكلات في الكود البرمجي.",
      tags: ["React Native", "Firebase", "Social"],
      icon: "fa-solid fa-code",
      price:"٨٥ $"
    },
    {
      title: "الترجمة الفورية",
      category: "translate",
      description:"ترجمة المحادثات أو الاجتماعات بشكل مباشر.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-language",
      price:"١٢٠  $"
    },
    {
      title: "التدقيق اللغوي",
      category: "translate",
      description:"مراجعة النصوص للتأكد من خلوها من الأخطاء",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-language",
      price:"١٥٠  $"
    },
    {
      title: " الفوريةالترجمة بين اللغات",
      category: "translate",
      description:"نقل النصوص من لغة إلى أخرى.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-language",
      price:"١٠٠  $"
    },
    {
      title: "تحويل الصوت إلى نص",
      category: "translate",
      description:"كتابة المحتوى المنطوق.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-language",
      price:"١١٠  $"
    },
    {
      title: "تحويل النصوص إلى صوت",
      category: "translate",
      description:"قراءة النصوص بصوت مسموع.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-language",
      price:"٦٠  $"
    },
    {
      title: "تحرير النصوص",
      category: "writing",
      description:"مراجعة وتعديل النصوص المكتوبة.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-book",
      price:"٩٠  $"
    },
        {
      title: "كتابة المقالات والمدونات",
      category: "writing",
      description:"إنشاء محتوى للمواقع والمدونات.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-book",
      price:"٣٠  $"
    },
        {
      title: "كتابة المحتوى التسويقي",
      category: "writing",
      description:"إعداد نصوص دعائية وإعلانية.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-book",
      price:"٤٠  $"
    },
    {
      title: "كتابة المحتوى التقني",
      category: "writing",
      description:"إعداد وثائق ودلائل تقنية.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-book",
      price:"٤٠  $"
    },
    {
      title: "كتابة السيناريوهات",
      category: "writing",
      description:"إعداد نصوص للأفلام أو الفيديوهات.",
      tags: ["Languages", "UI", "Dashboard"],
      icon: "fa-solid fa-book",
      price:"٣٥  $"
    },
  ];

  const filteredProjects =
    activeCategory === "all"
      ? projects
      : projects.filter((project) => project.category === activeCategory);

  useEffect(() => {
  if (showPayment && window.paypal) {
    const container = document.getElementById("paypal-button-container");
    if (!container) return;

    window.paypal.Buttons({
      style: {
        layout: 'vertical',
        color: 'blue',
        shape: 'pill',
        label: 'pay',
      },
      createOrder: function (data, actions) {
        const cleanPrice = parseFloat(
          selectedProject?.price?.replace(/[^\d.]/g, "") || "100"
        );
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: cleanPrice.toFixed(2),
            },
          }],
        });
      },
onApprove: function (data, actions) {
  return actions.order.capture().then(function (details) {
    alert(isEnglish
      ? `Transaction completed by ${details.payer.name.given_name}`
      : `تمت العملية بواسطة ${details.payer.name.given_name}`);

    const newOrder = {
      name: selectedProject.title,
      price: selectedProject.price,
      createdAt: new Date().toISOString(),
      deliveryDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
    };
    localStorage.setItem("cart", JSON.stringify(newOrder));

    setShowPayment(false);
    setSelectedProject(null);
  });
},

      onError: function (err) {
        console.error(err);
        alert(isEnglish ? "Payment failed!" : "فشلت عملية الدفع!");
      },
    }).render("#paypal-button-container");
  }
}, [showPayment]);


  return (
    <section style={{minHeight:"79vh"}} className={`${styles.projectsSection} ${styles[theme]}`}>
      <h2 className={styles.projectsTitle}>
        {isEnglish ? "Our Projects" : "مشاريعنا"}
      </h2>
      <p className={styles.projectsSubtitle}>
        {isEnglish
          ? "Explore our latest work and how we deliver creative digital solutions."
          : "استعرض أحدث أعمالنا وكيف نقدم حلول رقمية إبداعية."}
      </p>

      <div className={styles.servicesNavbar}>
        {services.map((service) => (
          <div
            key={service.key}
            className={`${styles.serviceItem} ${activeCategory === service.key ? styles.active : ""}`}
            onClick={() => setActiveCategory(service.key)}
          >
            <i className={service.icon}></i>
            <span>{service.label}</span>
          </div>
        ))}
      </div>

      <div  className={`${styles.projectsContainer} ${selectedProject ? styles.blurred : ""}`}>
        {filteredProjects.length === 0 ? (
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            {isEnglish ? "No projects available." : "لا توجد مشاريع متاحة."}
          </p>
        ) : (
          filteredProjects.map((project, index) => (
            <div key={index} className={`${styles.projectCard} ${isEnglish ? styles.leftShift : styles.rightShift}`}>
              <i className={`${project.icon} ${styles.projectIcon}`}></i>
              <h3>{project.title}</h3>
              <p style={{ direction: "rtl" }}>{project.description}</p>
              <div className={styles.projectButtons}>
                <button className={styles.btn} onClick={() => Tawk_API.maximize()}>
                  {isEnglish ? "Chat with me" : "سولني"}
                </button>
                <button className={styles.btn} onClick={() => setSelectedProject({ ...project, index })}>
                  {isEnglish ? "Buy it" : "شريني"}
                </button>
                <button className={styles.btn} onClick={() => setDetailProject(project)}>
                  {isEnglish ? "Details" : "تفاصيل"}
                </button>
                <RatingStars projectTitle={project.title} />
              </div>
            </div>
          ))
        )}
      </div>

      {/* نافذة الشراء */}
      {selectedProject && (
        <div className={styles.modal}>
          <h3>{selectedProject.title}</h3>
          <p>{isEnglish ? "Delivery time: 3 days" : "المدة المستغرقة: ٣ أيام"}</p>
          <p>  {isEnglish
                  ? `Price: ${selectedProject.price || "$100"}`
                  : `السعر: ${selectedProject.price || "١٠٠ دولار"}`}</p>
          <button
            className={styles.confirmBtn}
            onClick={() => setShowPayment(true)}
          >
            {isEnglish ? "Confirm here" : "أكد هنا"}
          </button>
          <button className={styles.closeBtn} onClick={() => {
            setSelectedProject(null);
            setShowPayment(false);
          }}>×</button>
        </div>
      )}

      {/* نافذة الدفع */}
      {showPayment && (
        <div className={styles.paymentModal}>
          <h3>{isEnglish ? "Payment Gateway" : "بوابة الدفع"}</h3>
          <div id="paypal-button-container"></div>
          <button className={styles.closeBtn} onClick={() => setShowPayment(false)}>×</button>
        </div>
      )}

      {/* نافذة تفاصيل العمل */}
      {detailProject && (
        <div className={styles.detailModal}>
          <div className={styles.detailContent}>
            <h2>{detailProject.title}</h2>
            <p>{detailProject.description}</p>
            <button
              className={styles.closeBtn}
              onClick={() => setDetailProject(null)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
}